import { createApiInstance } from './handler';
import { buildMetadata, buildMetadataQuery, getTargetFilters } from './metadata';

export const getProductTargets = async (auth) => {
  try {
    const targetFilters = await getTargetFilters(auth);
    return queryUsers(auth, targetFilters);
  } catch (reason) {
    console.log(reason); // TODO Some real logging
  }

  return Promise.resolve([]);
};

export const queryUsers = async (auth, attributesFilter) => {
  try {
    let metadataQuery = buildMetadataQuery(attributesFilter);
    const response = await createApiInstance(auth, 'client').get(`/users?limit=1000${metadataQuery}`);
    const users = response.data.data;
    if (users && users.length) {
      users.forEach((user) => {
        const transformedMetadata = buildMetadata(user.metadata);
        if (transformedMetadata) {
          user.eavs = user.metadata;
          user.metadata = transformedMetadata;
        } else {
          user.metadata = null;
        }
      });
    }
    const results = [];

    for (const user of users) {
      if (user.metadata) {
        results.push(user);
      }
    }

    return results;
  } catch (reason) {
    console.log(reason); // TODO Some real logging
  }

  return Promise.resolve([]);
};

export const getUser = async (auth, userId) => {
  try {
    const response = await createApiInstance(auth, 'client').get(`/users?user_ids=${userId}`);
    const userData = response.data.data;
    if (userData && userData.length) {
      const user = userData[0];
      const transformedMetadata = buildMetadata(user.metadata);
      if (transformedMetadata) {
        user.eavs = user.metadata;
        user.metadata = transformedMetadata;
      } else {
        user.metadata = null;
      }

      return user;
    }
  } catch (reason) {
    console.log(reason); // TODO Some real logging
  }

  return Promise.resolve(null);
};
